<div class="banner-wrapper">
    <!-- <div class="container-fluid"> -->
    <div class=""></div>
    <div class="row">
        <!-- <div class="col-lg-5 col-md-12"> -->
        <div class="col-lg-4 col-md-12">
            <div
                class="banner-wrapper-content"
                *ngFor="let Content of bannerWrapperContent"
            >
                <p
                    class="wow animate__animated animate__fadeInLeft eyebrowText"
                >
                    {{ Content.eyebrowText }}
                </p>
                <h1
                    class="wow animate__animated animate__fadeInLeft"
                    data-wow-delay="00ms"
                    data-wow-duration="1000ms"
                >
                    {{ Content.title }}
                </h1>
                <p
                    class="wow animate__animated animate__fadeInLeft"
                    data-wow-delay="100ms"
                    data-wow-duration="1000ms"
                >
                    {{ Content.paragraphText }}
                </p>
                <!-- <div class="btn-box">
                        <a routerLink="/{{Content.defaultBtnLink}}" class="default-btn wow animate__animated animate__fadeInRight" data-wow-delay="200ms" data-wow-duration="1000ms"><i class="{{Content.defaultBtnIcon}}"></i>{{Content.defaultBtnText}}<span></span></a>
                        <a routerLink="/{{Content.optionalBtnLink}}" class="default-btn wow animate__animated animate__fadeInRight" data-wow-delay="200ms" data-wow-duration="1000ms"><i class="{{Content.optionalBtnIcon}}"></i>{{Content.optionalBtnText}}<span></span></a>
                    </div> -->
            </div>
        </div>

        <!-- <div class="col-lg-7 col-md-12">
                <div class="banner-wrapper-animation-image">
                    <img src="assets/img/main-banner/banner-four/img1.png" class="wow animate__animated animate__fadeInDown" data-wow-delay="1000ms" data-wow-duration="1000ms" alt="image">
                    <img src="assets/img/main-banner/banner-four/img2.png" class="wow animate__animated animate__fadeInDown" data-wow-delay="1000ms" data-wow-duration="1000ms" alt="image">
                    <img src="assets/img/main-banner/banner-four/img3.png" class="wow animate__animated animate__fadeInDown" data-wow-delay="1000ms" data-wow-duration="1000ms" alt="image">
                    <img src="assets/img/main-banner/banner-four/img4.png" class="wow animate__animated animate__fadeInDown" data-wow-delay="1000ms" data-wow-duration="1000ms" alt="image">
                    <img src="assets/img/main-banner/banner-four/img5.png" class="wow animate__animated animate__fadeInUp" data-wow-delay="1000ms" data-wow-duration="1000ms" alt="image">
                    <img src="assets/img/main-banner/banner-four/img6.png" class="wow animate__animated animate__fadeInUp" data-wow-delay="1000ms" data-wow-duration="1000ms" alt="image">
                    <img src="assets/img/main-banner/banner-four/img7.png" class="wow animate__animated animate__fadeInDown" data-wow-delay="1000ms" data-wow-duration="1000ms" alt="image">
                    <img src="assets/img/main-banner/banner-four/img8.png" class="wow animate__animated animate__fadeInLeft" data-wow-delay="1000ms" data-wow-duration="1000ms" alt="image">
                    <img src="assets/img/main-banner/banner-four/img9.png" class="wow animate__animated animate__fadeInDown" data-wow-delay="5s00ms" data-wow-duration="1000ms" alt="image">
                    <img src="assets/img/main-banner/banner-four/img10.png" class="wow animate__animated animate__fadeInDown" data-wow-delay="00ms" data-wow-duration="1000ms" alt="image">
                    <img src="assets/img/main-banner/banner-four/main-pic.png" class="wow animate__animated animate__fadeInUp" data-wow-delay="100ms" data-wow-duration="1000ms" alt="image">
                </div>
            </div> -->
        <div class="col-lg-8 col-md-12">
            <!-- <div class="" *ngIf="error==true" style="text-align: center; color: red; font-size: 12px;">{{ errorText }}</div> -->
            <div class="card-container">
                <ng-container *ngFor="let stat of statData">
                    <material-tile
                        [stat]="stat"
                        class="mat-card"
                        *ngIf="stat.row === 0"
                    >
                        <canvas
                            [ngClass]="stat.preview ? 'preview' : 'full'"
                            [id]="stat.id"
                            width="250"
                            height="150"
                        ></canvas>
                    </material-tile>
                </ng-container>
            </div>
            <div class="card-container">
                <ng-container *ngFor="let stat of statData">
                    <material-tile
                        [stat]="stat"
                        class="mat-card"
                        *ngIf="stat.row === 1"
                    >
                        <!-- <div  *ngIf="stat.attributes.type==='v_bar'" id="backBtn" style="display: block;" class="go-back text-primary">Back</div> -->
                        <canvas
                            [ngClass]="stat.preview ? 'preview' : 'full'"
                            [id]="stat.id"
                            width="250"
                            height="150"
                        ></canvas>
                        <div
                            class="mat-card-footer"
                            *ngIf="stat.attributes.type === 'pie'"
                        >
                            This data excludes IT queries
                        </div>
                    </material-tile>
                </ng-container>
            </div>
            <div class="chart-note" *ngFor="let Content of chartNoteContent">
                <div class="note-title">{{ Content.title }}:</div>
                <ul *ngFor="let note of Content.note">
                    <li>{{ note }}</li>
                </ul>
            </div>
        </div>
    </div>
</div>
